/** Compare the entry module, not lazy chunks or cached application data. */
export function entryModule(html: string): string | undefined {
  for (const tag of html.match(/<script\b[^>]*>/gi) ?? []) {
    if (!/\btype\s*=\s*["']module["']/i.test(tag)) continue;
    const src = tag.match(/\bsrc\s*=\s*["']([^"']+)["']/i)?.[1];
    if (src?.startsWith("/assets/")) return src;
  }
}

export function mayReload(path: string, busy: boolean, editing: boolean) {
  return (path === "/home" || path === "/feed" || path === "/") && !busy && !editing;
}

export function watchHostedUpdates(options: {
  current: string;
  fetchLatest: () => Promise<string | undefined>;
  canReload: () => boolean;
  alreadyTried: (version: string) => boolean;
  reload: (version: string) => void;
}) {
  let pending: string | undefined;
  let checking = false;
  let disposed = false;
  function apply() {
    if (!disposed && pending && options.canReload() && !options.alreadyTried(pending)) {
      const version = pending;
      pending = undefined;
      options.reload(version);
    }
  }
  async function check() {
    if (checking || disposed) return;
    checking = true;
    try {
      const latest = await options.fetchLatest();
      if (latest && latest !== options.current) pending = latest;
      else pending = undefined;
      apply();
    } catch { /* Offline or failed checks must never interrupt the app. */ }
    finally { checking = false; }
  }
  return { check, apply, dispose: () => { disposed = true; } };
}
